import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

import { Store } from '@ngrx/store';
import { AppState } from '../../app.state';

import { KioskService } from '../kiosk.service';
import { getError, getTimer, KioskError, KioskTimer } from '../kiosk.reducer';
import { StartKioskTimer } from '../kiosk.actions';

@Component({
  selector: 'kiosk-error',
  template: require('./kiosk-error.component.html'),
  styles: [require('./kiosk-error.component.scss')],
  preserveWhitespaces: false,
})
export class KioskErrorComponent implements OnInit, OnDestroy {
  error$: Observable<KioskError>;
  errorType: typeof KioskError = KioskError;

  private destroyed: Subject<boolean> = new Subject();

  constructor(
    @Inject('$state') private $state,
    private kioskService: KioskService,
    private store: Store<AppState>,
  ) {};

  ngOnInit(): void {
    this.error$ = this.store.select(getError);

    this.store.dispatch(new StartKioskTimer());

    this.store.select(getTimer)
      .takeUntil(this.destroyed)
      .subscribe((timer: KioskTimer): void => {
        if (timer === KioskTimer.Inactive) {
          this.goBackHome();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroyed.next(true);
  }

  goBackHome(): void {
    this.$state.go('kiosk.home');
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/kiosk/kiosk-error/kiosk-error.component.ts